"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

interface PlanIconProps extends ComponentPropsWithoutRef<"img"> {
  slug: string;
}

export function usePlanIconSrc(slug: string) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (slug === "custom") return "/plan-icons/custom.png";

  if (!mounted) {
    return `/plan-icons/${slug}.svg`;
  }

  return resolvedTheme === "light"
    ? `/plan-icons/light/${slug}.svg`
    : `/plan-icons/${slug}.svg`;
}

export function PlanIcon({ slug, className, alt = "", ...props }: PlanIconProps) {
  const src = usePlanIconSrc(slug);

  return (
    <img
      src={src}
      alt={alt}
      className={cn("shrink-0", className)}
      onError={(event) => {
        const img = event.currentTarget;
        if (img.src.endsWith(`/light/${slug}.svg`)) {
          img.src = `/plan-icons/${slug}.svg`;
        }
      }}
      {...props}
    />
  );
}
